import $ from 'jquery';
import './widgetContoRisultati'

export default function widgetConto() {

  function init() {
    //Opzioni widget
    let tipoCliente = '0';
    let etaCliente = '0';
    let studente = '0';
    let accredito = '0';
    let modalita = '0';
    let servizi = '0';
    let dipendente = '0';
    let operazioni = '0';
    let carte = '0';
    let caratteristiche = '0';

    //Nav step
    $(document).on('click', '.box-widget .box-widget__btn', function() {
      let goToStep = $(this).data('gostep');

      if (typeof $(this).data('cliente') !== 'undefined') {
        tipoCliente = $(this).data('cliente');
        // console.log("stepCliente: " + $(this).data('cliente'));
      }
      if (typeof $(this).data('eta') !== 'undefined') {
        etaCliente = $(this).data('eta');
        // console.log("stepEta: " + $(this).data('eta'));
      }
      if (typeof $(this).data('studente') !== 'undefined') {
        studente = $(this).data('studente');
        // console.log("stepStudente: " + $(this).data('studente'));
      }
      if (typeof $(this).data('accredito') !== 'undefined') {
        accredito = $(this).data('accredito');
        // console.log("stepAccredito: " + $(this).data('accredito'));
      }
      if (typeof $(this).data('modalita') !== 'undefined') {
        modalita = $(this).data('modalita');
        // console.log("stepModalita: " + $(this).data('modalita'));
      }
      if (typeof $(this).data('servizi') !== 'undefined') {
        servizi = $(this).data('servizi');
        // console.log("servizi: " + $(this).data('servizi'));
      }
      if (typeof $(this).data('dipendente') !== 'undefined') {
        dipendente = $(this).data('dipendente');
        // console.log("dipendente: " + $(this).data('dipendente'));
      }
      if (typeof $(this).data('operazioni') !== 'undefined') {
        operazioni = $(this).data('operazioni');
        // console.log("operazioni: " + $(this).data('operazioni'));
      }
      if (typeof $(this).data('carte') !== 'undefined') {
        carte = $(this).data('carte');
        // console.log("carte: " + $(this).data('carte'));
      }
      if (typeof $(this).data('caratteristiche') !== 'undefined') {
        carte = $(this).data('caratteristiche');
        // console.log("caratteristiche: " + $(this).data('caratteristiche'));
      }
      
      if (goToStep == 'result') {
        let risultatoConto = tipoCliente.toString() + 
                        etaCliente.toString() + 
                        studente.toString() + 
                        accredito.toString() +
                        modalita.toString() +
                        servizi.toString() +
                        dipendente.toString() +
                        operazioni.toString() +
                        carte.toString() +
                        caratteristiche.toString();
        
        console.log("risultato conto: " + risultatoConto);
        let risultatoConsigliato = conto[risultatoConto];
        //riempio il risultato con il conto corretto
        $(".box-widget .box-widget__result").html('<div>' + risultatoConsigliato + '</div>');

        //mostro lo step finale
        $(this).parents('.box-widget').addClass('d-none');
        $('#result').removeClass('d-none');

        //reset widget
        tipoCliente = '0';
        etaCliente = '0';
        studente = '0';
        accredito = '0';
        modalita = '0';
        servizi = '0';
        dipendente = '0';
        operazioni = '0';
        carte = '0';
        caratteristiche = '0';

      } else {

        //controllo le opzioni da mostrare nello step successivo
        if (typeof $(this).data('nextoption') !== 'undefined') {
          let showNextOption = $(this).data('nextoption');

          $('#'+goToStep).find('.box-widget__btn').addClass('d-none');
          $('#'+goToStep).find('.box-widget__btn[data-section='+showNextOption+']').removeClass('d-none');
        }

        //passo allo step cliccato
        $(this).parents('.box-widget').addClass('d-none');
        $('#'+goToStep).removeClass('d-none');
      }
    });

    //Start
    $(document).on('click', '.box-widget.start-widget', function() {
      $(this).addClass('d-none');
      $('#start').removeClass('d-none');
    });

    //Undo button
    $(document).on('click', '.box-widget .box-widget__undo', function() {
      tipoCliente = '0';
      etaCliente = '0';
      studente = '0';
      accredito = '0';
      modalita = '0';
      servizi = '0';
      dipendente = '0';
      operazioni = '0';
      carte = '0';
      caratteristiche = '0';

      $('.box-widget').addClass('d-none');
      $('.box-widget.start-widget').removeClass('d-none');
    });
  }
  
  $( document ).ready(function() {
    if($('#widgetConto').length > 0) {
      init();
    }
  });  
}




























